import { mockAccounts } from '../data/mockAccounts';
import { mockJournalEntries } from '../data/mockJournals';
import { mockDeclarations } from '../data/mockDeclarations';
import { mockLedgerEntries } from '../data/mockLedgerEntries';
import { mockNotifications } from '../data/mockNotifications';
import type { ApiResponse } from './api/types';

export class FallbackService {
  private static fallbackEnabled = true;
  
  static enableFallback(enabled: boolean = true) {
    this.fallbackEnabled = enabled;
  }

  static async getFallbackData<T>(endpoint: string): Promise<ApiResponse<T> | null> {
    if (!this.fallbackEnabled) {
      return null;
    }

    console.warn(`🔄 Using fallback data for ${endpoint}`);

    try {
      switch (true) {
        case endpoint.includes('/accounts'):
          return { success: true, data: mockAccounts as any };
          
        case endpoint.includes('/journal-entries'):
          return { success: true, data: { data: mockJournalEntries, pagination: { page: 1, pageSize: 20, total: mockJournalEntries.length, totalPages: 1 } } as any };
          
        case endpoint.includes('/declarations'):
          return { success: true, data: { data: mockDeclarations, pagination: { page: 1, pageSize: 20, total: mockDeclarations.length, totalPages: 1 } } as any };
          
        case endpoint.includes('/ledger/trial-balance'):
          return { success: true, data: mockLedgerEntries as any };
          
        case endpoint.includes('/fiscal-years'):
          return { 
            success: true, 
            data: [{
              id: '1',
              code: '2024',
              startDate: '2024-01-01',
              endDate: '2024-12-31',
              status: 'open' as const
            }] as any 
          };
          
        case endpoint.includes('/notifications'):
          return { 
            success: true, 
            data: { 
              notifications: mockNotifications, 
              unreadCount: mockNotifications.filter(n => !n.read).length,
              pagination: { page: 1, pageSize: 20, total: mockNotifications.length, totalPages: 1 } 
            } as any 
          };
          
        case endpoint.includes('/users'):
          return { 
            success: true, 
            data: [{
              id: '1',
              name: 'Admin User',
              email: 'admin@wanzo.com',
              role: 'admin'
            }] as any 
          };
          
        default:
          return null;
      }
    } catch (error) {
      console.error('Fallback service error:', error);
      return null;
    }
  }
}
